import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCall } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const registerPropertyApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCall({
      url: apiConstants.Property.REGISTER_NEW_PROPERTY,
      method: 'post',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        errorCallBack && errorCallBack(error.response)
        toast.error(compileErrors(error.response.data.error))
            })
  }
}
